import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fdfa368"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "question-sub-caption" }, " Установите соответствие. Перетаскивайте нижние блоки на соответствующие поля в таблице ", -1))
const _hoisted_2 = {
  key: 0,
  class: "correspondence-table__caption-strike"
}
const _hoisted_3 = { class: "correspondence-table__row" }
const _hoisted_4 = ["onDrop"]
const _hoisted_5 = ["onDragstart"]
const _hoisted_6 = ["onDragstart"]

import { useTestStore } from "@/store/UserTestModule";
import { computed, ref } from "vue";
import IAnswer from "../../interfaces/IAnswer";


export default /*#__PURE__*/_defineComponent({
  __name: 'CorrespondenceQuestionComponent',
  setup(__props, { expose: __expose }) {

const testStore = useTestStore();
const currentQuestion = computed(() => {
  return testStore.currentQuestion;
});

const mutateCurrentQuestion = computed(() => {
  let newQuestion = {
    questionGroupId: currentQuestion.value.questionGroupId,
    questionId: currentQuestion.value.questionId,
    questionTypeId: currentQuestion.value.questionTypeId,
    text: currentQuestion.value.text,
    answers: [] as IAnswer[],
  };
  for (let i = 0; i < currentQuestion.value.answers.length; i++) {
    newQuestion.answers.push({
      answerId: currentQuestion.value.answers[i].answerId,
      text: currentQuestion.value.answers[i].text,
      answerUser: currentQuestion.value.answers.find(
        (item) => item.answerUser == i
      )?.text,
      questionId: currentQuestion.value.answers[i].questionId,
      questionTypeId: currentQuestion.value.answers[i].questionTypeId,
      caption: currentQuestion.value.answers[i].caption,
    });
  }
  return newQuestion;
});

const tableHeader = ref();
const table = ref();

const tableWidth = computed(() => {
  if (table.value) {
    return table.value.offsetWidth;
  }
  return window.innerWidth - 100;
});

const widthForElements = computed(() => {
  if (tableHeader.value) {
    return tableWidth.value / tableHeader.value.length + 2 + "px";
  } else {
    return "200px";
  }
});

const preCells = ref();
const isNextDisabledCorrespondence = computed(() => {
  if (preCells.value) {
    return preCells.value.length !== 0;
  } else {
    return false;
  }
});

function dragAnswerStart(event: DragEvent, item: any) {
  if (event.dataTransfer != undefined) {
    event.dataTransfer.dropEffect = "move";
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("itemId", item.answerId);
  }
  event.target.classList.add("dragging");
}

function dragAnswerEnd(event: DragEvent) {
  event.target.classList.remove("dragging");
}

function onDropAnswer(event: any, index: number) {
  const itemId = event.dataTransfer.getData("itemId");
  const answer = currentQuestion.value.answers.find(
    (item) => item.answerId == itemId
  );
  answer.answerUser = index;
  checkAnswers(itemId, index);
  testStore.setUserAnswer(mutateCurrentQuestion.value);
}

function onReturnAnswer(event: any, value: null) {
  const itemId = event.dataTransfer.getData("itemId");
  const answer = currentQuestion.value.answers.find(
    (item) => item.answerId == itemId
  );
  answer.answerUser = value;
  testStore.setUserAnswer(mutateCurrentQuestion.value);
}

function checkAnswers(itemId, index) {
  if (
    currentQuestion.value.answers.filter((item) => item.answerUser == index)
      .length > 1
  ) {
    currentQuestion.value.answers
      .filter((item) => item.answerUser == index)
      .forEach((element) => {
        if (element.answerId != itemId) {
          element.answerUser = null;
        }
      });
  }
}

__expose({
  isNextDisabledCorrespondence,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("table", {
      ref_key: "table",
      ref: table,
      class: "correspondence-table"
    }, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers, (answer, index) => {
          return (_openBlock(), _createElementBlock("th", {
            ref_for: true,
            ref_key: "tableHeader",
            ref: tableHeader,
            style: _normalizeStyle('width:' + widthForElements.value),
            class: "correspondence-table__caption",
            key: index
          }, [
            _createTextVNode(_toDisplayString(answer.caption) + " ", 1),
            (index !== currentQuestion.value.answers.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2))
              : _createCommentVNode("", true)
          ], 4))
        }), 128))
      ]),
      _createElementVNode("tr", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers, (answer, index) => {
          return (_openBlock(), _createElementBlock("td", {
            style: _normalizeStyle('width:' + widthForElements.value),
            class: "correspondence-table__cell",
            key: index,
            onDrop: ($event: any) => (onDropAnswer($event, index)),
            onDragenter: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers.filter(
            (item) => item.answerUser == index
          ), (answer, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "correspondence-table__cell-after",
                style: _normalizeStyle('width:' + widthForElements.value),
                key: index,
                draggable: "true",
                onDragstart: ($event: any) => (dragAnswerStart($event, answer))
              }, _toDisplayString(answer.text), 45, _hoisted_5))
            }), 128))
          ], 44, _hoisted_4))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", {
      class: "pre-cell-wrapper",
      onDrop: _cache[3] || (_cache[3] = ($event: any) => (onReturnAnswer($event, null))),
      onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
      onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers.filter(
        (item) => item.answerUser === null
      ), (answer, index) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle('width:' + widthForElements.value),
          class: "pre-cell-wrapper__cell",
          key: index,
          ref_for: true,
          ref_key: "preCells",
          ref: preCells,
          draggable: "true",
          onDragstart: ($event: any) => (dragAnswerStart($event, answer)),
          onDragend: _cache[2] || (_cache[2] = ($event: any) => (dragAnswerEnd($event)))
        }, _toDisplayString(answer.text), 45, _hoisted_6))
      }), 128))
    ], 32)
  ], 64))
}
}

})